export default "__VITE_ASSET__1e6c7165__"